import React from 'react';
import { FacebookScript } from './scripts/FacebookScript';
import { FidesScript } from './scripts/FidesScript';
import { SegmentScript } from './scripts/SegmentScript';

export const GlobalScripts: React.FC = () => {
  return (
    <>
      <FidesScript />
      <FacebookScript />
      <SegmentScript />
    </>
  );
};
